import React, { useEffect, useState } from "react";
import Switch from "../../../../../../../components/Inputs/Switch/Switch";
import styles from '../styles.module.scss';
import { FormControlLabel, IconButton, Radio, RadioGroup, withStyles } from "@material-ui/core";
import Button from "../../../../../../../components/Buttons/Button";
import TextInput from "../../../../../../../components/Inputs/TextInput";
import { ExpandLessRounded, ExpandMoreRounded } from "@material-ui/icons";
import FlexRow from "../../../../../../../components/FlexBox/FlexRow";
import SButton from "../../../../../../../components/SButton/SButton";

const INCORRECT_ERROR = "Serial number doesn't support the configuration";

const StyledRadio = withStyles({
    root: {
        color: '#BDC7D9',
        '&$checked': {
            color: '#03BFFF',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);


const ChannelConfiguration = ({ hNext, hBack, accessPointDetails, channelCount = 4, inProgress = false }) => {
    const [channelDetails, setChannelDetails] = useState({});
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {

    }, [accessPointDetails])

    useEffect(() => {
        if (accessPointDetails?.channelDetails) {
            setChannelDetails(JSON.parse(JSON.stringify(accessPointDetails?.channelDetails)))
        } else {
            const channels = {}
            for (let i = 0; i < channelCount; i++) {
                channels[`channel${i + 1}`] = {
                    accessPointName: '',
                    entryDeviceSerialNum: {
                        value: '',
                        description: '',
                        error: '',
                    },
                    exitDeviceSerialNum: {
                        value: '',
                        description: '',
                        error: '',
                    },
                    checked: false,
                    show: false
                }
            }
            setChannelDetails(JSON.parse(JSON.stringify(channels)));
        }
    }, [channelCount, accessPointDetails])

    useEffect(() => {
        let disabledValue = false;
        let checkCount = 0;
        Object?.keys(channelDetails)?.forEach(channel => {
            const currentChannel = channelDetails[channel];

            if (currentChannel?.checked) {
                checkCount = checkCount + 1;
            }

            if (!currentChannel?.wireProtocol && currentChannel?.checked) {
                disabledValue = true
            }

            if (accessPointDetails?.configuration.formOptions.entry && currentChannel?.checked) {
                if (currentChannel?.entryDeviceSerialNum?.value === '' || currentChannel?.entryDeviceSerialNum?.error !== '') {
                    disabledValue = true;
                }
            }

            if (accessPointDetails?.configuration?.formOptions?.exit && currentChannel?.checked) {
                if (currentChannel?.exitDeviceSerialNum?.value === '' || currentChannel?.exitDeviceSerialNum?.error !== '') {
                    disabledValue = true;
                }
                if (
                    currentChannel?.entryDeviceSerialNum?.value?.substring(0, 4) !== currentChannel?.exitDeviceSerialNum?.value?.substring(0, 4)
                ) {
                    disabledValue = true;
                }
                if (currentChannel?.entryDeviceSerialNum?.value === currentChannel?.exitDeviceSerialNum?.value) {
                    disabledValue = true;
                }
            }

            if (currentChannel?.checked && currentChannel?.accessPointName?.trim()?.length <= 0) {
                disabledValue = true;
            }
        })
        if (checkCount === 0) {
            disabledValue = true;
        }
        setDisabled(disabledValue);
    }, [
        accessPointDetails?.configuration.formOptions.entry,
        accessPointDetails?.configuration.formOptions.exit,
        channelDetails
    ]);

    function checkError(value, field) {
        if (field === 'entry') {
            if (!accessPointDetails?.configuration?.validSerials?.entry?.includes(value?.substring(0, 4))) {
                return INCORRECT_ERROR;
            } else if (value.length !== 14) {
                return 'Please enter a valid Serial Number';
            } else {
                return '';
            }
        }
        if (field === 'exit') {
            if (!accessPointDetails?.configuration?.validSerials?.exit?.includes(value?.substring(0, 4))) {
                return INCORRECT_ERROR;
            } else if (value.length !== 14) {
                return 'Please enter a valid Serial Number';
            } else {
                return '';
            }
        }
    }

    const handleSerialDescription = (value, field, channel) => {
        const switchCase = value.substring(0, 4);
        let description = '';
        switch (String(switchCase)) {
            case '1001':
            case '1002':
            case '1016':
            case '101F':
            case '1021':
            case '1026':
            case '1032':
            case '1028':
            case '1029':
            case '1033':
            case '1034':
            case '103B':
            case '103A':
            case '103F':
            case '1042':
                description = 'Mobile/Card';
                break;
            case '1023':
            case '1015':
                description = 'Mobile/Card/Fingerprint';
                break;
            case '1024':
            case '1025':
            case '103D':
            case '102F':
                description = 'Face/Card';
                break;
            case '102D':
                description = 'Face';
                break;
            case '1027':
                description = 'Mobile';
                break;
            case '1038':
                description = 'Mobile/QR/Card';
                break;
            default:
                break;
        }

        let error = '';

        error = checkError(value, field);

        if (field === 'entry') {
            hChannelDetails(channel, 'entryDeviceSerialNum', { description: description, value: value?.trim(), error: error })
        }
        if (field === 'exit') {
            hChannelDetails(channel, 'exitDeviceSerialNum', { description: description, value: value?.trim(), error: error })
        }
    };


    const handleNext = () => {
        const toSend = {
            channelDetails
        }
        hNext && hNext(toSend, 4);
    }

    const hChannelDetails = (channel, key, value) => {
        if (channel && key) {
            setChannelDetails(prev => ({ ...prev, [channel]: { ...prev[channel], [key]: value } }))
        }
    }

    return (<>
        <div className={styles['column-container']} style={{ gap: '1rem', width: '100%', marginBottom: '2rem' }}>

            {Object?.keys(channelDetails)?.map((cDetails, i) => (
                <div style={{ marginBottom: '2rem' }}>
                    <div className={styles['row']}>
                        <div className={styles['column']}>
                            <h2 className={styles['bold-text']}>Channel {i + 1}</h2>
                            <p className={styles['note']}>Enter details for channel {i + 1}</p>
                        </div>
                        <Switch
                            checked={channelDetails[cDetails]?.checked}
                            onChange={() => {
                                const checked = !channelDetails[cDetails]?.checked
                                hChannelDetails(cDetails, 'checked', checked);
                                if (checked) {
                                    hChannelDetails(cDetails, 'show', true);
                                } else {
                                    hChannelDetails(cDetails, 'show', false);
                                }
                            }}
                        />
                        <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            disabled={!channelDetails[cDetails]?.checked}
                            onClick={() => { hChannelDetails(cDetails, 'show', !channelDetails[cDetails]?.show) }}
                        >
                            {channelDetails[cDetails]?.show ?
                                <ExpandLessRounded style={{ color: '#4CC0F8' }} fontSize="large" /> :
                                <ExpandMoreRounded style={{ color: '#4CC0F8' }} fontSize="large" />
                            }

                        </IconButton>
                    </div>
                    <div className={styles['divider']} style={{ marginTop: '0' }} />
                    {channelDetails[cDetails]?.show &&
                        <>
                            <TextInput
                                name=""
                                placeholder="Access Point Name"
                                value={channelDetails[cDetails]?.accessPointName}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    hChannelDetails(cDetails, 'accessPointName', value?.trimStart())
                                }}
                            />

                            {accessPointDetails?.configuration?.formOptions?.entry && (
                                <TextInput
                                    name=""
                                    maxLength={14}
                                    description={channelDetails[cDetails]?.entryDeviceSerialNum?.description}
                                    placeholder={`Entry Reader Serial Number`}
                                    value={channelDetails[cDetails]?.entryDeviceSerialNum?.value}
                                    error={channelDetails[cDetails]?.entryDeviceSerialNum?.error}
                                    onChange={(e) => handleSerialDescription(e.target.value, 'entry', cDetails)}
                                />
                            )}
                            {accessPointDetails?.configuration?.formOptions?.exit && (
                                <TextInput
                                    name=""
                                    maxLength={14}
                                    description={channelDetails[cDetails]?.exitDeviceSerialNum?.description}
                                    placeholder="Exit Reader Serial Number"
                                    value={channelDetails[cDetails]?.exitDeviceSerialNum?.value}
                                    error={channelDetails[cDetails]?.exitDeviceSerialNum?.error}
                                    onChange={(e) => handleSerialDescription(e.target.value, 'exit', cDetails)}
                                />
                            )}
                            {channelDetails[cDetails]?.entryDeviceSerialNum?.value?.substring(0, 4) !==
                                channelDetails[cDetails]?.exitDeviceSerialNum?.value?.substring(0, 4) &&
                                accessPointDetails?.configuration?.formOptions?.exit && (
                                    <p className={styles.access_alert}>
                                        Your entry device and exit device serial numbers are not matching
                                    </p>
                                )}

                            {channelDetails[cDetails]?.entryDeviceSerialNum?.value && channelDetails[cDetails]?.entryDeviceSerialNum?.value === channelDetails[cDetails]?.exitDeviceSerialNum?.value &&
                                accessPointDetails?.configuration?.formOptions?.exit && (
                                    <p className={styles.access_alert}>
                                        Your entry device and exit device cannot be the same
                                    </p>
                                )}
                            <h2 className={styles['bold-text']} style={{ fontWeight: '500', marginBottom: '1.5rem', marginTop: '2rem', color: '#4766B7' }}>Communication Protocol</h2>
                            <RadioGroup aria-label="Communication-Protocol" name="communicationProtocol" value={channelDetails[cDetails]?.wireProtocol} onChange={(e) => {
                                const value = e.target.value;
                                hChannelDetails(cDetails, 'wireProtocol', value)
                            }}>
                                <FormControlLabel value="3" control={<StyledRadio />} label={'OSDP'} />
                                <FormControlLabel value="2" control={<StyledRadio />} label="Weigand" />
                            </RadioGroup>
                        </>
                    }
                </div>
            ))}

        </div>

        <FlexRow styles={{ marginTop: '1rem' }} justifyContent="end" className={styles["fixed-actions"]}>
            <SButton disabled={inProgress} color={"grey"} minWidth onClick={() => { hBack && hBack(2) }}>Back</SButton>
            <SButton disabled={inProgress || disabled} minWidth onClick={handleNext}>Next</SButton>
        </FlexRow>
    </>)
};

export default ChannelConfiguration;